import { lazy } from "react";

const Login = lazy(() => import("@pages/login"));
const ResetPwd = lazy(() => import("@pages/resetPassword"));
const SafeWarning = lazy(() => import("@pages/safeWarning"));
const NotFound = lazy(() => import("@pages/404/NotFound"));
const AssessmentOpinionPage = lazy(
  () =>
    import(
      "@pages/supplier/SupplierProfile/components/EvaluationTab/QRCodeSignature/AssessmentOpinionPage"
    ),
);
const DrawSignaturePage = lazy(
  () =>
    import(
      "@pages/supplier/SupplierProfile/components/EvaluationTab/QRCodeSignature/DrawSignaturePage"
    ),
);

const homeRoute = [
  {
    path: "/login",
    name: "登录页",
    component: Login,
  },
  {
    path: "/resetPassword",
    name: "重置密码",
    component: ResetPwd,
  },
  {
    path: "/safeWarning",
    name: "安全提示",
    component: SafeWarning,
  },
  {
    path: "/supplier/assessment-opinion",
    name: "评审意见",
    component: AssessmentOpinionPage,
  },
  {
    path: "/supplier/assessment-opinion/signature",
    name: "签名",
    component: DrawSignaturePage,
  },
  {
    path: "/404",
    name: "404",
    component: NotFound,
  },
];
export default homeRoute;
